klevu.coreEvent.build({
  name: 'setRemoteConfigLandingOverride',
  fire: function () {
    if (
      klevu.getSetting(
        klevu,
        'settings.flags.setRemoteConfigLanding.build',
        false
      )
    ) {
      return true;
    }
    return false;
  },
  maxCount: 150,
  delay: 100,
});

klevu.coreEvent.attach('setRemoteConfigLandingOverride', {
  name: 'attachRemoteConfigLandingOverride',
  fire: function () {
    //override template to add button
    klevu.search.landing
      .getScope()
      .template.setTemplate(
        klevu.dom.helpers.getHTML('#klevuLandingTemplateFiltersCustom'),
        'filters',
        true
      );
    // attach click event to button
    klevu.search.landing.getScope().chains.template.events.add({
      name: 'applyFilters',
      fire: function (data, scope) {
        var target = klevu.getSetting(
          scope.kScope.settings,
          'settings.search.searchBoxTarget'
        );
        klevu.each(
          klevu.dom.find('#kuFilterOpener', target),
          function (key, value) {
            klevu.event.attach(value, 'click', function (event) {
              document
                .getElementsByTagName('body')[0]
                .classList.toggle('filter_opened');
            });
          }
        );
      },
    });

    //power up landing
    klevu({
      powerUp: {
        landing: true,
      },
    });
  },
});

jQuery(document).ready(checkResultPage);

function checkResultPage () {
   if(jQuery('#klevuLanding').text() == '') {
     setTimeout(checkResultPage, 50);
   } else {
     jQuery(".kuFilterHead").click();
     //jQuery(".kuLoadMoreBtn").removeClass("hide");
   }
}
